import React from 'react';
import { Small } from '@dbk/ui-text';
import {
  Chart,
  XAxis,
  YAxis,
  Grid,
  ScatterChart,
  LineChart,
  Interaction,
  scaleLinear,
  scaleBar,
} from '@dbk/ui-charts';
import { IntlProvider } from '@dbk/ui-format';
import { CHART_CONFIG } from '../constants'
import { Currency } from '../../../../../../../../../src/components/common/number';
import { formatChartDate } from '../trade-utils';

const TradeSecurityPriceChart = (props) => {
  const { chartData, currencyCode, langCode } = props;

  return (
    <div className="trade-price-chart-container"  >
      <Chart
        maxHeight={CHART_CONFIG.MAX_HEIGHT}
        data={chartData}
        axis={{
          x: {
            scale: scaleBar,
            ticks: data => data,
            tickFormatter: d => formatChartDate(d, CHART_CONFIG.DATE_FORMAT_OPTIONS_X_AXIS,
              langCode)
          },
          y: {
            scale: o => scaleLinear(o).nice(3)
          }
        }}
        ratio={2}
        margins={{
          left: CHART_CONFIG.MARGIN.LEFT,
          right: CHART_CONFIG.MARGIN.RIGHT,
          top: CHART_CONFIG.MARGIN.TOP,
          bottom: CHART_CONFIG.MARGIN.BOTTOM}}
        paddings={{
          left: CHART_CONFIG.PADDINGS.LEFT,
          right: CHART_CONFIG.PADDINGS.RIGHT,
          top: CHART_CONFIG.PADDINGS.TOP,
          bottom: CHART_CONFIG.PADDINGS.BOTTOM
        }}
        extendToNextTick
      >
        <XAxis
          key="xaxis" />
        <YAxis
        showLine={false}
        showTicks={false} />
        <Grid />
        <LineChart color={CHART_CONFIG.COLOR} />
        <ScatterChart color={CHART_CONFIG.COLOR} />
        <Interaction xAxis="x">
          <Interaction.XGroup>
            <Interaction.VerticalLine
              top={-5}
              wrapper={Interaction.HideLink}
              gaps={[{ axis: 'y', gap: 11 }]}

            />
            <Interaction.Circle d={11} />
            <Interaction.DataPointView view={data =>
              <div
                className="trade-price-chart-flag"
              >
                {currencyCode && <IntlProvider locale={langCode}>
                  <Small secondary>
                    <Currency
                      currency={currencyCode}
                      value={data.y}
                    />
                  </Small>
                </IntlProvider>}<br />
                <Small
                  secondary>
                  {formatChartDate(data.x, CHART_CONFIG.DATE_FORMAT_OPTIONS_FLAG, langCode)}
                </Small>

              </div>
            } />
          </Interaction.XGroup>
        </Interaction>
      </Chart>
    </div>
  )
};

export default TradeSecurityPriceChart;
